import { createMuiTheme } from '@/theme'
import { StyleSheet } from '@react-pdf/renderer'

const styles = () => {
  const theme = createMuiTheme({})

  return StyleSheet.create({
    // primaryText: { color: theme.palette.primary.main },
    primaryText: { color: 'red' },
    secondaryText: { color: theme.palette.btn_positive.main },
    title: { fontSize: 25, fontWeight: 'bold' },
    section: { padding: 20 },
  })
}

export default styles()
